import script from "./LocationSuccesSVG.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationSuccesSVG.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__